import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  Typography,
  CircularProgress,
} from "@mui/material";
import Swal from "sweetalert2";
import RequestPageMUI from "./RequestPageMUI";
import apiClient from "@/api/client";

const DanaGilanpasaRequests = () => {
  // State for the custom approval dialog
  const [approveDialogOpen, setApproveDialogOpen] = useState(false);
  const [currentRow, setCurrentRow] = useState(null);
  const [approveData, setApproveData] = useState({
    monks_count: "",
    reason: "",
  });
  const [submitting, setSubmitting] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  // Called when the "Approve" action is triggered in the DataGrid
  const handleApprove = (row, newStatus) => {
    setCurrentRow(row);
    setApproveData({ monks_count: "", reason: "" });
    setApproveDialogOpen(true);
  };

  // Submit the approval
  const handleApproveSubmit = async () => {
    const { monks_count, reason } = approveData;
    if (!monks_count || !reason) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Both Monks Count and Reason are required.",
        confirmButtonColor: "#c49b36",
      });
      return;
    }
    setSubmitting(true);
    try {
      const response = await apiClient.put(
        `/gilan-pasa-request/${currentRow.id}/status`,
        {
            status: 'Approved',
            status_reason: approveData.reason,  // field name from frontend
            monks_count: parseInt(approveData.monks_count, 10),
        }
    );
      Swal.fire({
        icon: "success",
        title: "Success",
        text: response.data.message || "Request approved successfully.",
        confirmButtonColor: "#c49b36",
      });
      setApproveDialogOpen(false);
      setRefreshKey((prev) => prev + 1); // refresh the table
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.message || error.message,
        confirmButtonColor: "#c49b36",
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <RequestPageMUI
        key={refreshKey}
        title="Gilanpasa Requests"
        fetchUrl="/get-gilan-pasa-requests"
        editEndpoint="edit-gilan-pasa-request"
        deleteEndpoint="gilan-pasa-request"
        statusEndpoint="gilan-pasa-request" // still used for Reject/On hold
        dateFields={['date', 'created_at', 'updated_at']}
        hiddenFields={['ip_address']}
        onApprove={handleApprove} // <-- custom approval handler
      />

      {/* Approval Dialog */}
      <Dialog
        open={approveDialogOpen}
        onClose={() => !submitting && setApproveDialogOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Approve Gilanpasa Request</DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 1 }}>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              Reference: {currentRow?.reference_no}
            </Typography>
            <TextField
              autoFocus
              margin="dense"
              label="Number of Monks"
              type="number"
              fullWidth
              value={approveData.monks_count}
              onChange={(e) =>
                setApproveData({ ...approveData, monks_count: e.target.value })
              }
              required
              inputProps={{ min: 0 }}
            />
            <TextField
              margin="dense"
              label="Reason / Message"
              multiline
              rows={3}
              fullWidth
              value={approveData.reason}
              onChange={(e) =>
                setApproveData({ ...approveData, reason: e.target.value })
              }
              required
              placeholder="E.g., Approved by coordinator, notes..."
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setApproveDialogOpen(false)} disabled={submitting}>
            Cancel
          </Button>
          <Button
            onClick={handleApproveSubmit}
            variant="contained"
            color="success"
            disabled={submitting}
          >
            {submitting ? <CircularProgress size={24} /> : "Confirm Approval"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DanaGilanpasaRequests;